
import { Options, Vue } from "vue-class-component"; //基本需要
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import { ElMessage } from "element-plus";
import * as echarts from "echarts";
import { store } from "@/store"; //引入仓库
import {
  readDateVersions,
  readNewReport,
  readNewReportList,
  readPerformances,
  readPerfReport,
  readRecentTaskrecord,
  readTaskRecordDevices,
  readTaskRecordQuery,
  readPerformanceVersion,
} from "@/store/performance/getters"; //引入仓库接口
import {
  dispatchCreateReport,
  dispatchGetPerfReport,
  dispatchGetReportDetail,
  dispatchUploadReportImage,
  dispatchtaskRecordQuery,
  dispatchtaskRecordDevices,
  dispatchAovCopyPerfToReport,
  dispatchGetNewReportList,
  dispatchDeleteReport,
  dispatchGetDateVersionList,
  dispatchRecentTaskrecord,
  dispatchCreateReportByTask,
  dispatchGetPerformanceVersion,
  dispatchClearCache,
} from "@/store/performance/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import {
  dispatchGetProjectDetail,
  dispatchGetProjectScenes,
} from "@/store/project/actions";
import _FormItem from "element-plus/lib/el-form-item";
import {
  readHeroSkin,
  readMobaProjects,
  readUserProfile,
} from "@/store/main/getters";
import {
  dispatchGetHeroSkin,
  dispatchGetMobaProjects,
  dispatchUpdateMyLastProject,
} from "@/store/main/actions";
import { readMyProjects, readProjectDetail } from "@/store/project/getters";

// 导入组件SideMenu:2
@Options({
  components: {
    SideMenu,
  },
})
export default class TestReport extends Vue {
  //export default必不可少，否则会报错哦

  // 声明属性
  public contrast = true;
  public dialogFormVisible = false; // 生成报告的弹窗是否可见
  public dialogFormVisibleByTask = false; // 生成报告的弹窗是否可见
  public generateReportVersion = {
    // 弹窗内——生成报告的新/旧版本
    oldEdition: "",
    newEdition: "",
    scenetion: [],
  };
  public interval = 3; // 默认对比几轮数据
  public localProject = Number(getLocalProject()); //得到本地的项目
  public report_id = 0; //报告的id
  public com_risk = "低风险"; //共同风险
  public new_report: any = {
    //新报告需要的数据类型
    id: 0,
    new_version: "",
    old_version: "",
    test_info: "",
    risk: null,
    create_date: "",
    settings: JSON.stringify({
      rule_settings: {
        change_rule: {
          increase_good: ["avg_fps"],
          threshold: {},
        },
        risk_rule: {},
        tdr_risk_rule: {},
      },
      report_settings: {
        content: {
          core_index: ["avg_fps", "max_pss"], //核心指数
          trend_index: ["avg_fps", "max_pss"], //趋势指数
          exclude_scene: [], //排除场景
          exclude_device: [], //排除设备
          show_index: [
            "max_pss",
            "avg_fps",
            "fps_lt_10_pcnt",
            "fps_lt_18_pcnt",
            "fps_lt_25_pcnt",
          ], //显示索引
          index_type: {
            //索引类型
            basic: ["max_pss", "avg_fps"], //基础指标
            advance: ["fps_lt_10_pcnt", "fps_lt_18_pcnt", "fps_lt_25_pcnt"], //深度指标
            customize: [], //定制指标
          },
          trend_number: 10, //趋势指数
          trend_integrity: true, // 趋势图的完整性, 是否允许有缺失数据, 有断点, 1: 允许数据缺失, 0:不允许数据缺失
          red_only_change_value: false, // 是否仅标红变化值, 核心风险详情表格, 里面只标红括号内变化的值
          core_color_rule: false, // 核心指标标红规则, 1:变差就标红, 0: 超过阈值才标红
        },
        notify: {
          //通知
          email: {
            enable: false,
            receiver: [], //接收
          },
          wecom: {
            enable: false,
            receiver: [],
          },
          wecom_robot: {
            enable: false,
            receiver: [],
          },
        },
      },
    }),
    creator: "",
  };
  public get_core_data = {
    //获取核心数据的数据类型
    able_versions: {
      android_new_version: "",
      android_old_version: "",
      ios_new_version: "",
      ios_old_version: "",
    },
    all_echart_data_v1: {
      date_list: [],
      performance_briefs: [],
    },
    report_data: {},
    report_list: [],
    report_list1: [],
    new_version: "",
    old_version: "",
    old_version1: "",
    all_devices: [],
    report_list2: [
      {
        scene_id: 0,
        scene: "",
        old_version: "",
        custom_index: [],
        device_list: [],
        old: [
          {
            data: { url: "", game_version: "" },
          },
        ],
        new: [
          {
            data: { url: "", game_version: "" },
            device: "",
            level: "",
          },
        ],
        standard: [],
      },
    ],
    all_echart_versions: [],
    all_echart_data: [
      { performance_briefs: [{ device_id: 0 }], date_list: [] },
    ],
    project: {
      icon: "",
      project_name: "",
    },
    all_device_id: [],
    str_list: [],
    hero_list: [],
    skin_list: [],
    all_hero_skins: {},
    core_devices1: [],
    core_devices2: [],
    compare_result: {
      one: {},
      two: {},
      three: {},
    },
  };

  // public report_name_placeholder = "";
  public get_field(field: string, control = false) {
    const fields = {
      avg_fps: "平均FPS", // 平均FPS
      avg_pss: "均值PSS",
      max_pss: "PSS峰值", // 峰值PSS
      max_mono_used: "maxMonoUsed(M)", // 峰值Used Mono
      max_mono_total: "峰值mono内存(M)", // 峰值Total Mono
      avg_cpu: "平均CPU", // 平均CPU
      fps_lt_10_pcnt: "FPS<=10占⽐(%)", // FPS<=10占有率(%)
      fps_lt_18_pcnt: "FPS>=18占⽐(%)", // FPS>=18占有率(%)
      fps_lt_25_pcnt: "FPS>=25占⽐(%)", // FPS>=25占有率(%)
      fps_lt_40_pcnt: "FPS>=40占⽐(%)", // FPS>=40占有率(%)
      cpu_lt_60_pcnt: "CPU<=60占⽐(%)", // FPS<=60占有率(%)
      cpu_lt_80_pcnt: "CPU<=80占⽐(%)", // FPS<=80占有率(%)
      dps: "dps",
      avg_dc: "平均DC", // 平均DC
      max_dc: "峰值DrawCall数", // 峰值DC
      max_triangle: "峰值三角形数", // 峰值三角形(万)
      duration: "耗时", // 耗时
      avg_flow: "流量(KB/S)", // 流量(KB/S)
      max_swap: "maxSwap",
      max_vss: "maxVss",
      max_swap_add_pss: "maxSwapAddPss",
      process_up_flow: "进程上行流量[KB/s]",
      process_down_flow: "进程下行流量[KB/s]",
      logic_up_flow: "逻辑上行流量[KB/s]",
      logic_down_flow: "逻辑下行流量[KB/s]",
      lag_cnt: "卡顿次数", // 卡顿次数
      single_peak_lag_cnt: "singlePeakLagCnt",
      multiple_peak_lag_cnt: "multiplePeakLagCnt",
      continue_low_lag_cnt: "continueLowLagCnt",
      lag_pcnt: "卡顿率", // 卡顿率
      lag_freq: "卡顿频率",
      id_row_start: "id_row_start",
      id_row_end: "id_row_end",
      id_frame_start: "id_frame_start",
      id_frame_end: "id_frame_end",
      avg_cpu_total: "avgCpuTotal",
      gc_cnt: "GC(次)", // gc_cnt
      gc_freq: "GC频率",
      cpu_temp: "CPU温度",
    };
    return typeConversion(field, fields, control); //类型转换
  }
  public loading = false; //加载

  // 取得仓库数据
  public get getDeviceSpecs() {
    // 设备列表
    const devices = readDeviceSpecs(store);
    return devices;
  }
  // public get getPerformanceSelectOptions() {
  //   //获取性能选择选项
  //   return readPerformanceSelectOptions(store);
  // }
  public get getDateVersions() {
    return readDateVersions(store);
  }
  public get getPerformances() {
    //获取性能数据
    const performances: any[] = readPerformances(store);
    return performances;
  }
  public perf_report() {
    //性能报告核心数据
    this.get_core_data = readPerfReport(store);
  }
  public get_create_report() {
    //获取新报告
    this.new_report = readNewReport(store);
    this.new_report.create_date = dateConversion(this.new_report.create_date);
  }
  public generateReportsManually() {
    // 手动生成报告
    this.dialogFormVisible = true;
    this.generateReportVersion.oldEdition = "";
    this.generateReportVersion.newEdition = "";
  }
  public generateReportsManuallyByTask() {
    this.dialogFormVisibleByTask = true;
    this.generateReportVersion.oldEdition = "";
    this.generateReportVersion.newEdition = "";
    this.report_name_placeholder = "【GR自动化性能】项目名-new";
  }
  public save_report(is_auto?: boolean) {
    //发送报告
    let upload_data: any;
    if (typeof is_auto === "boolean") {
      upload_data = {
        project: this.$route.query.project
          ? this.$route.query.project
          : Number(this.localProject),
        report_id: this.$route.query.report_id
          ? this.$route.query.report_id
          : Number(this.name_search),
        file_list: this.resBase64,
        is_auto: is_auto,
        title: this.formMail.title,
        recv: this.formMail.addressee,
        cc: this.formMail.CC_List,
        interval: this.interval,
        send: this.formMail.Sender,
      };
    } else {
      upload_data = {
        project: this.$route.query.project
          ? this.$route.query.project
          : Number(this.localProject),
        report_id: this.$route.query.report_id
          ? this.$route.query.report_id
          : Number(this.name_search),
        file_list: this.resBase64,
        title: this.formMail.title,
        recv: this.formMail.addressee,
        cc: this.formMail.CC_List,
        interval: this.interval,
        send: this.formMail.Sender,
      };
    }

    dispatchUploadReportImage(store, upload_data);
    ElMessage({
      //Message 消息提示
      message: "报告发送中...",
      showClose: true,
    });
  }
  public get screenshot() {
    if ("screenshot" in this.$route.query) {
      return false;
    } else {
      return true;
    }
  }

  public resBase64: any[] = [];
  public corePerformance: any[] = [];
  // 页面初始化
  public async mounted() {
    this.loading = true;
    if (this.$route.query.report_id) {
      if (this.$route.query.project) {
        const project = Number(this.$route.query.project);
        // 记录一下最后访问的项目
        dispatchUpdateMyLastProject(store, { last_visit_project: project });
        saveLocalProject(String(project));
        saveLocalStorageProject(String(project));
        this.reload();
        // 获取当前报告名称列表
        dispatchGetDeviceSpecs(store, {
          project: project,
        });
        // dispatchGetPerformanceSelectOptions(store, {
        //   project: project,
        // });
        dispatchGetDateVersionList(store, {
          project: project,
        });
        dispatchRecentTaskrecord(store, { project: this.localProject });
        await dispatchGetNewReportList(store, {
          project: this.localProject,
          report_type: 0,
        });
        (this.name_search as any) = Number(this.$route.query.report_id);
        await dispatchGetMobaProjects(store, project);
        if (this.projectIsKing) {
          dispatchGetHeroSkin(store, project);
        }
        await dispatchGetReportDetail(store, {
          project: project,
          id: Number(this.$route.query.report_id),
        });
        this.report_id = readNewReport(store).id;
        await dispatchGetPerfReport(store, {
          project: project,
          report_id: Number(this.$route.query.report_id),
          interval: this.interval,
        });

        await this.perf_report();
        this.scene_options; //选择场景
        await this.get_create_report(); //启用生成报告的接口

        this.resBase64 = [];
        await this.legendArr.map((item, index) => {
          this.$nextTick(() => {
            this.performanceTrends_echarts(index, item.value); //图表
          });
        });
        // 从浏览器触发发送报告
        if ("screenshot" in this.$route.query) {
          this.save_report();
        }
      } else {
        dispatchGetDeviceSpecs(store, {
          project: this.localProject,
        });
        // dispatchGetPerformanceSelectOptions(store, {
        //   project: this.localProject,
        // });
        dispatchGetDateVersionList(store, {
          project: this.localProject,
        });
        dispatchRecentTaskrecord(store, { project: this.localProject });
        await dispatchGetMobaProjects(store, this.localProject);
        if (this.projectIsKing) {
          dispatchGetHeroSkin(store, this.localProject);
        }
        await dispatchGetReportDetail(store, {
          project: this.localProject,
          id: Number(this.$route.query.report_id),
        });
        this.report_id = readNewReport(store).id;
        await dispatchGetPerfReport(store, {
          project: this.localProject,
          report_id: Number(this.$route.query.report_id),
          interval: this.interval,
        });

        await this.perf_report();
        this.scene_options; //选择场景
        await this.get_create_report(); //启用生成报告的接口
        this.resBase64 = [];
        // aov数据
        await this.legendArr.map((item, index) => {
          this.$nextTick(() => {
            this.performanceTrends_echarts(index, item.value); //图表
          });
        });
      }
    } else {
      dispatchGetDateVersionList(store, {
        project: this.localProject,
      });
      dispatchRecentTaskrecord(store, { project: this.localProject });
      dispatchGetDeviceSpecs(store, { project: this.localProject });
      await dispatchGetNewReportList(store, {
        project: this.localProject,
        report_type: 0,
      });

      this.name_search = readNewReportList(store)[0].id;
      this.$router.push({
        query: { ...this.$route.query, report_id: this.name_search },
      });
      // 邮件标题
      this.formMail.title = (readNewReportList(store) as any[]).filter(
        (item: any) => item.id === this.name_search
      )[0].report_name;
      await dispatchGetReportDetail(store, {
        project: this.localProject,
        id: Number(this.name_search),
      });
      await this.addressee; //解析邮件收件人

      this.report_id = readNewReport(store).id;
      await dispatchGetPerfReport(store, {
        project: this.localProject,
        report_id: Number(this.name_search),
        interval: this.interval,
      });
      await this.perf_report();
      await this.get_create_report(); //启用生成报告的接口
      await dispatchGetProjectDetail(store, {
        id: this.localProject,
        project: this.localProject,
      });
      await dispatchGetMobaProjects(store, this.localProject);
      if (this.projectIsKing) {
        dispatchGetHeroSkin(store, this.localProject);
      }
      await dispatchGetProjectScenes(store, { project: this.localProject });
    }
    await this.getCorePerformance();
    await dispatchtaskRecordQuery(store, {
      project: this.localProject,
      task_record_id: "",
    }); //aov复制数据需要的任务记录列表接口
    await dispatchtaskRecordDevices(store, {
      project: this.localProject,
      task_record_id: "",
    }); //获取任务记录的设备
    this.get_core_data.report_list.unshift(this.get_core_data.report_list[0]);
    this.resBase64 = [];
    await this.legendArr.map((item, index) => {
      this.$nextTick(() => {
        this.performanceTrends_echarts(index, item.value); //图表
      });
    });
    // await this.scrollBar()//判断是否有滚动条
    await this.noDecimal();

    await this.judgeModel;
    this.loading = false;
  }

  // 核心指标性能趋势数据
  public getCorePerformance() {
    if (this.get_core_data.report_list.length > 0) {
      this.corePerformance.push({
        title: "新场景:",
        data: this.get_core_data.report_list,
        compare: this.get_core_data.core_devices1,
        edition: this.get_core_data.old_version,
      });
    }
    if (this.get_core_data.report_list1.length > 0) {
      this.corePerformance.push({
        title: "老场景:",
        data: this.get_core_data.report_list1,
        compare: this.get_core_data.core_devices2,
        edition: this.get_core_data.old_version1,
      });
    }
    return this.corePerformance;
  }

  public get get_hero_skin_config() {
    return readHeroSkin(store);
  }

  // 邮件
  public sendReport = {
    title: "",
    Sender: "",
    addressee: "",
    copy: "",
  };
  public report_name_placeholder = "【GR自动化性能】项目名-新版本号"; //弹窗内默认项目名称
  // 激活报告名称
  // public activation(val: boolean) {
  //   if (val) {
  //     this.report_name_placeholder =
  //       "【GR自动化性能】" +
  //       this.get_project_name +
  //       " -" +
  //       this.generateReportVersion.newEdition;
  //   } else {
  //     this.report_name_placeholder =
  //       "【GR自动化性能】" +
  //       this.get_project_name +
  //       " -" +
  //       this.generateReportVersion.newEdition.split("|")[0];
  //   }
  // }
  // 得到项目名称
  public get get_project_name() {
    const project_name = readProjectDetail(store).project_name;
    return project_name;
  }

  // 弹窗、表格 —— 游戏版本选择列表
  public get game_version_options() {
    const versions = this.getDateVersions.game_versions; //获取性能选择选项里的有些版本
    const game_version_select: any[] = [];
    versions.forEach((item) => {
      if (item.value) {
        game_version_select.push({
          label: item.label,
          value: item.value,
        });
      } else {
        game_version_select.push({
          label: "空版本",
          value: "null_version",
        });
      }
    });
    return game_version_select;
  }

  // 生成报告
  public async generateReport() {
    if (
      this.generateReportVersion.oldEdition === "" ||
      this.generateReportVersion.newEdition === ""
    ) {
      alert("版本号不能为空哦！");
      return;
    }
    this.loading = true;
    this.dialogFormVisible = false;
    await dispatchCreateReport(store, {
      //调用创建报告的接口，将所需数据传递过去
      project: this.localProject,
      new_version: this.generateReportVersion.newEdition.split("|")[0],
      old_version: this.generateReportVersion.oldEdition.split("|")[0],
      timestamp: this.generateReportVersion.newEdition.split("|")[1],
      old_timestamp: this.generateReportVersion.oldEdition.split("|")[1], // 老版本截止日期
      // report_name: this.report_name_placeholder,
      scene_list: this.generateReportVersion.scenetion,
    });

    this.loading = true;
    dispatchGetDateVersionList(store, {
      project: this.localProject,
    });
    // dispatchGetPerformanceSelectOptions(store, {
    //   project: this.localProject,
    // });
    dispatchGetDeviceSpecs(store, { project: this.localProject });
    dispatchRecentTaskrecord(store, { project: this.localProject });
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 0,
    });

    this.name_search = readNewReportList(store)[0].id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.name_search },
    });
    // 邮件标题
    this.formMail.title = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.name_search
    )[0].report_name;
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: readNewReportList(store)[0].id,
    });
    await this.addressee; //解析邮件收件人

    this.report_id = readNewReport(store).id;
    await dispatchGetPerfReport(store, {
      project: this.localProject,
      report_id: readNewReportList(store)[0].id,
      interval: this.interval,
    });
    this.datum_result = {};
    await this.perf_report();
    await this.get_create_report(); //启用生成报告的接口
    await dispatchGetMobaProjects(store, this.localProject);
    if (this.projectIsKing) {
      dispatchGetHeroSkin(store, this.localProject);
    }
    await dispatchGetProjectScenes(store, { project: this.localProject });
    this.corePerformance = [];
    await this.getCorePerformance();
    // await dispatchtaskRecordQuery(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //aov复制数据需要的任务记录列表接口
    // await dispatchtaskRecordDevices(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //获取任务记录的设备
    this.get_core_data.report_list.unshift(this.get_core_data.report_list[0]);
    this.resBase64 = [];
    await this.legendArr.map((item, index) => {
      this.$nextTick(() => {
        this.performanceTrends_echarts(index, item.value); //图表
      });
    });
    // await this.scrollBar()//判断是否有滚动条
    await this.noDecimal();

    await this.judgeModel;
    this.loading = false;
  }
  // 生成报告
  public async generateReportByTask() {
    this.loading = true;
    this.dialogFormVisibleByTask = false;
    await dispatchCreateReportByTask(store, {
      //调用创建报告的接口，将所需数据传递过去
      project: this.localProject,
      task_record_id: Number(this.generateReportVersion.newEdition),
      old_record_id: Number(this.generateReportVersion.oldEdition),
      // report_name: this.report_name_placeholder,
      // allow: this.contrast,
    });

    this.loading = true;
    dispatchGetDateVersionList(store, {
      project: this.localProject,
    });
    // dispatchGetPerformanceSelectOptions(store, {
    //   project: this.localProject,
    // });
    dispatchGetDeviceSpecs(store, { project: this.localProject });
    dispatchRecentTaskrecord(store, { project: this.localProject });
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 0,
    });

    this.name_search = readNewReportList(store)[0].id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.name_search },
    });
    // 邮件标题
    this.formMail.title = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.name_search
    )[0].report_name;
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: readNewReportList(store)[0].id,
    });
    await this.addressee; //解析邮件收件人

    this.report_id = readNewReport(store).id;
    await dispatchGetPerfReport(store, {
      project: this.localProject,
      report_id: readNewReportList(store)[0].id,
      interval: this.interval,
    });
    this.datum_result = {};
    await this.perf_report();
    await this.get_create_report(); //启用生成报告的接口
    await dispatchGetMobaProjects(store, this.localProject);
    if (this.projectIsKing) {
      dispatchGetHeroSkin(store, this.localProject);
    }
    await dispatchGetProjectScenes(store, { project: this.localProject });
    this.corePerformance = [];
    await this.getCorePerformance();
    // await dispatchtaskRecordQuery(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //aov复制数据需要的任务记录列表接口
    // await dispatchtaskRecordDevices(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //获取任务记录的设备
    this.get_core_data.report_list.unshift(this.get_core_data.report_list[0]);
    this.resBase64 = [];
    await this.legendArr.map((item, index) => {
      this.$nextTick(() => {
        this.performanceTrends_echarts(index, item.value); //图表
      });
    });
    // await this.scrollBar()//判断是否有滚动条
    await this.noDecimal();

    await this.judgeModel;
    this.loading = false;
  }

  //核心性能指标趋势

  //将新报告的JSON 字符串转换为对象。
  public get report_set() {
    const settings = JSON.parse(this.new_report.settings);
    return settings.report_settings;
  }

  // 数值变化的规则配置
  public get rule_set() {
    const settings = JSON.parse(this.new_report.settings);
    return settings.rule_settings;
  }
  // 趋势对比
  public compore_num(
    new_value: number,
    old_value: number,
    param: string,
    row?: any,
    device?: any
  ) {
    let level = device?.level;
    let device_type = device?.type;
    if (device_type === 0) {
      device_type = "Android";
    } else if (device_type === 1) {
      device_type = "iOS";
    }
    if (!new_value) {
      return ["", "", ""];
    }
    let res: any = 0;
    if (old_value) {
      res = parseFloat((new_value - old_value).toFixed(1));
    }

    let risk = "";
    let color = ""; // 核心表格差值颜色
    let style = ""; // 核心表格原值颜色
    let new_color = ""; //详情表格差值颜色
    let is_rule = false;
    if (res !== 0) {
      // 风险判断,在increase_good中的上升标为绿色，下降为红色，如果配置有threshold，则变动超出阈值才标记颜色
      if (this.rule_set.change_rule.increase_good.includes(param)) {
        // 风险评估阈值(变化值)
        if (
          this.rule_set.risk_rule?.[param] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            typeof this.rule_set.risk_rule?.[param] !== "number" &&
            this.rule_set.risk_rule?.[param].search("%") !== -1
          ) {
            // 阈值类型为百分比: 5%
            if (
              (old_value - new_value) / old_value >
              Number(
                this.rule_set.risk_rule?.[param].substring(
                  0,
                  this.rule_set.risk_rule?.[param].indexOf("%")
                )
              ) *
                0.01
            ) {
              is_rule = true;
              risk = "高风险";
              this.com_risk = "高风险";
            }
          } else {
            // 阈值类型为绝对值: 32
            if (
              old_value - new_value >
              Number(this.rule_set.risk_rule?.[param])
            ) {
              is_rule = true;
              risk = "高风险";
              this.com_risk = "高风险";
            }
          }
        }
        // 风险评估阈值(绝对值)
        if (
          this.rule_set?.abs_risk_rule?.[param] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (new_value < this.rule_set?.abs_risk_rule?.[param]) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
        // 按照设备的档位，类型判定风险, 判定规则：新版本数值超过阈值
        if (
          this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
            param
          ] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            new_value <
            this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
              param
            ]
          ) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
        // 颜色配置
        if (this.rule_set.change_rule.threshold?.[param]) {
          if (
            Math.abs(new_value - old_value) / old_value >
            this.rule_set.change_rule.threshold?.[param]
          ) {
            color = "#606266"; // 灰黑色
            new_color = "red";
          } else {
            color = "#00b050"; // 绿色
            new_color = "#00b050";
          }
        } else {
          if (res > 0) {
            color = "#00b050"; // 绿色
            new_color = "#00b050";
          } else {
            color = "#606266"; // 灰黑色
            new_color = "red";
          }
        }
      } else {
        if (
          this.rule_set.risk_rule?.[param] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            typeof this.rule_set.risk_rule?.[param] !== "number" &&
            this.rule_set.risk_rule?.[param].search("%") !== -1
          ) {
            // 阈值类型为百分比: 5%
            if (
              (new_value - old_value) / old_value >
              Number(
                this.rule_set.risk_rule?.[param].substring(
                  0,
                  this.rule_set.risk_rule?.[param].indexOf("%")
                )
              ) *
                0.01
            ) {
              risk = "高风险";
              is_rule = true;
              this.com_risk = "高风险";
            }
          } else {
            // 阈值类型为绝对值: 32
            if (
              new_value - old_value >
              Number(this.rule_set.risk_rule?.[param])
            ) {
              is_rule = true;
              risk = "高风险";
              this.com_risk = "高风险";
            }
          }
        }
        // 风险评估阈值(绝对值)
        if (
          this.rule_set?.abs_risk_rule?.[param] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (new_value > this.rule_set?.abs_risk_rule?.[param]) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
        // TDR标准
        if (
          this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
            param
          ] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            new_value >
            this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
              param
            ]
          ) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
        // 颜色规则
        if (this.rule_set.change_rule.threshold?.[param]) {
          if (
            Math.abs(new_value - old_value) / old_value >
            this.rule_set.change_rule.threshold?.[param]
          ) {
            color = "#606266"; // 灰黑色
            new_color = "red";
          } else {
            color = "#00b050"; // 绿色
            new_color = "#00b050";
          }
        } else {
          if (res > 0) {
            color = "#606266"; // 灰黑色
            new_color = "red";
          } else {
            color = "#00b050"; // 绿色
            new_color = "#00b050"; // 绿色
          }
        }
      }
      // 指标变化规则判断
      if (row) {
        if (res > 0) {
          res = "(" + Math.abs(res) + "↑" + ")";
        } else if (res < 0) {
          res = "(" + Math.abs(res) + "↓" + ")";
        }
      } else {
        if (res > 0) {
          res = Math.abs(res) + "↑";
        } else if (res < 0) {
          res = Math.abs(res) + "↓";
        }
      }
    } else {
      if (this.rule_set.change_rule.increase_good.includes(param)) {
        // 风险评估阈值(绝对值)
        if (
          this.rule_set?.abs_risk_rule?.[param] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (new_value < this.rule_set?.abs_risk_rule?.[param]) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
        // TDR标准, 按照设备的档位，类型判定风险, 判定规则：新版本数值超过阈值
        if (
          this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
            param
          ] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            new_value <
            this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
              param
            ]
          ) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
      } else {
        // 风险评估阈值(绝对值)
        if (
          this.rule_set?.abs_risk_rule?.[param] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (new_value > this.rule_set?.abs_risk_rule?.[param]) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
        // TDR标准
        if (
          this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
            param
          ] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            new_value >
            this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
              param
            ]
          ) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
      }
      res = row ? "(--)" : "";
    }

    if (risk === "高风险" && row) {
      row[param] = "高风险";
      if (!this.report_set.content.red_only_change_value) {
        style = "color: red; font-weight: bold;";
      }
      if (is_rule) {
        color = "red;font-weight: bold;";
      }
    } else {
      risk = "低风险";
    }
    if (this.report_set.content.core_color_rule) {
      // 核心指标标红规则, 变差就标红
      color = new_color;
    }
    // [差值, 风险, 核心表格差值颜色, 核心表格原值颜色, 详情表格差值颜色]
    return [res, risk, color, style, new_color];
  }

  //趋势图

  //性能指标初始化
  public selected_target = this.report_set.content.trend_index[0] || "";
  // 获取是否是moba项目
  public get is_in_moba_project() {
    const moba = readMobaProjects(store);
    return moba;
  }
  // 项目是否是王者荣耀
  public get projectIsKing() {
    //9
    if ((this.is_in_moba_project as any).includes(this.localProject)) {
      return true;
    } else {
      return false;
    }
  }
  public get_device_label(devie: string, index: number) {
    if (
      this.projectIsKing &&
      Object.keys(this.get_core_data.all_hero_skins).length !== 0
    ) {
      const hero =
        (this.get_hero_skin_config.skin_list as any[]).filter(
          (item) =>
            Number(item.hero_id) ===
            this.get_core_data.all_hero_skins?.[devie].hero_id
        )[0]?.hero_name || "无英雄";
      const skin =
        (this.get_hero_skin_config.skin_list as any[]).filter(
          (item) =>
            Number(item.skin_id) ===
              this.get_core_data.all_hero_skins?.[devie].hero_id &&
            Number(item.hero_id) ===
              this.get_core_data.all_hero_skins?.[devie].skin_id
        )[0]?.skin_name || "无皮肤";
      return devie + "\n" + hero + "-" + skin;
    } else {
      // return devie.split('(')[1].split(')')[0] + "\n" + devie.split('(')[0];
      return devie;
    }
  }
  //场景选项
  public get scene_options() {
    const scene = readPerfReport(store).all_echart_data; //性能报告数据
    var sceneOptions: any[] = []; //场景
    for (let i in scene) {
      sceneOptions.push({
        scene_id: scene[i].scene_id,
        chinese: scene[i].scene,
      });
    }
    return sceneOptions;
  }
  // 指标选项
  public get target_types() {
    let target_select: any[] = [];
    this.report_set.content.trend_index.forEach((item: any) => {
      target_select.push({
        label: this.get_field(item),
        value: item,
      });
    });
    return target_select;
  }
  public async clear() {
    this.loading = true;
    await dispatchClearCache(store, {
      project: this.localProject,
      report_id: Number(this.name_search),
    });
    // await dispatchGetReportDetail(store, {
    //   project: this.localProject,
    //   id: Number(this.name_search),
    // });
    await this.addressee; //解析邮件收件人
    await dispatchGetPerfReport(store, {
      project: this.localProject,
      report_id: Number(this.name_search),
    });
    this.datum_result = {};
    await this.perf_report();
    await this.get_create_report(); //启用生成报告的接口
    dispatchGetDateVersionList(store, {
      project: this.localProject,
    });
    // dispatchGetPerformanceSelectOptions(store, {
    //   project: this.localProject,
    // });
    dispatchGetDeviceSpecs(store, { project: this.localProject });
    await dispatchGetMobaProjects(store, this.localProject);
    if (this.projectIsKing) {
      dispatchGetHeroSkin(store, this.localProject);
    }
    await dispatchGetProjectScenes(store, { project: this.localProject });
    this.corePerformance = [];
    await this.getCorePerformance();
    this.get_core_data.report_list.unshift(this.get_core_data.report_list[0]);
    this.resBase64 = [];
    await this.legendArr.map((item, index) => {
      this.$nextTick(() => {
        this.performanceTrends_echarts(index, item.value); //图表
      });
    });
    await this.noDecimal();

    await this.judgeModel;
    this.loading = false;
  }
  // 详细测试数据
  // 索引分类
  public indexClassification(custom_index: string[]) {
    const settings = JSON.parse(this.new_report.settings);
    const index = settings.report_settings.content.index_type;
    let indexClassification: any[] = [];
    indexClassification.push({
      indexClassification: "指标分类",
      dataItem: "数据项",
    });
    (index.basic as any[]).forEach((item) =>
      indexClassification.push({
        indexClassification: "基础指标",
        dataItem: this.get_field(item),
        style: { "background-color": "#51792e" },
      })
    );
    (index.advance as any[]).forEach((item) =>
      indexClassification.push({
        indexClassification: "深度指标",
        dataItem: this.get_field(item),
        style: { "background-color": "#fdc108" },
      })
    );
    (index.customize as any[]).forEach((item) =>
      indexClassification.push({
        indexClassification: "定制指标",
        dataItem: this.get_field(item),
        style: { "background-color": "#ef7b2a" },
      })
    );
    custom_index.forEach((item) =>
      indexClassification.push({
        indexClassification: "定制指标",
        dataItem: item,
        style: { "background-color": "#ef7b2a" },
      })
    );
    return indexClassification;
  }

  // 链接
  public get_url(url: string) {
    let new_url = url;
    if (url) {
      let url_arr = url.split("/");
      if (url_arr[2] !== "runmax.oa.com") {
        let current_herf = window.parent.location.href;
        let f = current_herf.split("/");
        let domain = f[2];
        url_arr[2] = domain;
        new_url = url_arr.join("/");
        return new_url;
      }
    }
    return url;
  }

  // 获取所有的索引
  public all_index(custom_index: string[]) {
    const settings = JSON.parse(this.new_report.settings);
    const index = settings.report_settings.content.index_type;
    let indexs = [];
    indexs.push(...index.basic);
    indexs.push(...index.advance);
    indexs.push(...index.customize);
    indexs.push(...custom_index);
    return indexs;
  }

  public time: any = "";
  public reload() {
    this.time = new Date().getTime();
  }

  public Level: any[] = [
    { label: "超高端机", value: 0 },
    { label: "高端机", value: 1 },
    { label: "中端机", value: 2 },
    { label: "低端机", value: 3 },
    { label: "超低端机", value: 4 },
  ];
  // 设备
  public get all_device_options() {
    const devices = this.get_core_data.all_echart_data;
    const device_select: any[] = [];
    devices.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item.performance_briefs[0]?.device_id
      )[0];
      let name =
        this.Level.filter((item3) => item3.value === device?.level)[0]?.label +
        device?.model?.name;
      device_select.push({
        label: name,
        value: item,
      });
    });
    return device_select;
  }
  // 指标
  public legendArr = [
    {
      label: "PSS峰值",
      value: "max_pss",
    },
    {
      label: "平均FPS",
      value: "avg_fps",
    },
    {
      label: "Mono堆内存峰值",
      value: "monomem",
    },
    {
      label: "Drawcall均值",
      value: "avg_dc",
    },
    {
      label: "loading时间均值",
      value: "loadingtime",
    },
    {
      label: "FrameSync",
      value: "FrameSync",
    },
    {
      label: "卡顿次数(10m)",
      value: "Jank(/10min)",
    },
    {
      label: "严重卡顿次数(10m)",
      value: "BigJank(/10min)",
    },
  ];
  public game_scene_version = [];
  public get getDateVersionsList() {
    return readPerformanceVersion(store);
  }
  public async selectVersion() {
    await dispatchGetPerformanceVersion(store, {
      project: this.localProject,
      version: (this.generateReportVersion.newEdition as any).split("|")[0],
      timestamp:
        (this.generateReportVersion.newEdition as any).split("|")[1] || "",
    });
    this.game_scene_version = this.getDateVersionsList.scene_list;
  }
  // 图表
  public performanceTrends_echarts(index: any, titleVal: any) {
    // 数据处理
    this.get_core_data.all_echart_data_v1?.performance_briefs.forEach(
      (item: any) => {
        item.forEach((item1: any) => {
          let newArr: any;
          if (item1.custom_data !== undefined) {
            newArr = { ...item1, ...JSON.parse(item1.custom_data) };
            if (
              item1.avg_dc === "" ||
              item1.avg_dc === null ||
              item1.avg_dc === undefined
            ) {
              item1.avg_dc = item1.dc;
            }
          }
          item1.newArr = newArr;
        });
      }
    );
    let seriesData2: any[] = [];

    this.get_core_data.all_echart_data_v1?.performance_briefs.forEach(
      (item: any, index: any) => {
        let dataVal: any[] = [];
        item.map((item2: any) => {
          dataVal.push(item2.newArr[titleVal]);
        });
        seriesData2.push({
          type: "line",
          name: this.get_core_data.all_devices[index],
          data: dataVal,
          // yAxisIndex: index,
          symbol: "circle", //拐点设置为实心
          smooth: true,
          itemStyle: { normal: { label: { show: true } } },
        });
      }
    );

    let performanceTrends: any = document.getElementById(
      "Performance_trends" + index
    );
    echarts.dispose(performanceTrends);
    let PerformanceLineChart = echarts.init(performanceTrends);
    let option;
    option = {
      title: {
        text: this.legendArr[index].label + "趋势图",
        x: "left",
        textStyle: {
          fontWeight: "bold",
          fontSize: 18,
        },
      },
      tooltip: {
        show: true,
        trigger: "axis",
      },
      legend: {
        x: "center",
        y: "bottom",
        data: this.get_core_data.all_devices,
      },
      grid: {
        left: "2%",
        right: "5%",
        bottom: "10%",
        top: "15%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {},
          magicType: { show: true, type: ["bar", "line"] },
        },
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: this.get_core_data.all_echart_data_v1.date_list,
        // offset: 0,
      },
      yAxis: {
        show: true,
        type: "value",
        scale: true,
        offset: 20,
      },
      series: seriesData2,
      animation: false,
    };
    PerformanceLineChart.setOption(option);
    var res_base64 = PerformanceLineChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename =
      "aov" +
      index +
      "_project" +
      this.localProject +
      "_report" +
      this.$route.query.report_id +
      ".png";
    this.resBase64.push(res);
    return PerformanceLineChart;
  }

  // aov测试数据
  public testData = [
    {
      label: "平均FPS",
      value: "avg_fps",
    },
    {
      label: "loading时间均值",
      value: "loadingtime",
    },
    {
      label: "帧率>18比例(%)",
      value: "fps_lt_18_pcnt",
    },
    {
      label: "帧率>25比例(%)",
      value: "fps_lt_25_pcnt",
    },
    {
      label: "帧率方差",
      value: "Var(FPS)",
    },
    {
      label: "单帧>100ms比例(%)",
      value: "FTime>=100[%]",
    },
    {
      label: "卡顿次数(10m)",
      value: "Jank(/10min)",
    },
    {
      label: "严重卡顿次数(10m)",
      value: "BigJank(/10min)",
    },
    {
      label: "PSS内存均值(MB)",
      value: "Avg(Memory)[MB]",
    },
    {
      label: "PSS内存峰值(MB)",
      value: "max_pss",
    },
    {
      label: "Mono已用内存峰值(MB)",
      value: "monomem",
    },
    {
      label: "Mono堆内存峰值(MB)",
      value: "avg_monomem",
    },
    {
      label: "GC次数",
      value: "gc",
    },
    {
      label: "DrawCall均值",
      value: "avg_dc",
    },
    {
      label: "三角形数均值",
      value: "Tris",
    },
    {
      label: "顶点数均值",
      value: "Verts",
    },
    {
      label: "UI_dc",
      value: "UI_dc",
    },
    {
      label: "HUD_dc",
      value: "HUD_dc",
    },
    {
      label: "Scene_dc",
      value: "Scene_dc",
    },
    {
      label: "Particle_dc",
      value: "Particle_dc",
    },
    {
      label: "FrameSync",
      value: "FrameSync",
    },
    {
      label: "LogicThr",
      value: "LogicThr",
    },
    {
      label: "SleepTime",
      value: "SleepTime",
    },
    {
      label: "PostTime",
      value: "PostTime",
    },
    {
      label: "平均CPU",
      value: "avg_cpu",
    },
    {
      label: "最高温度",
      value: "max_cpu_temp",
    },
  ];

  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }

  // 复制数据
  public copyVal = {
    taskRecordId: "", //任务记录id
    deviceVal: "", //任务记录设备
  };
  // 获取复制需要的任务id下拉框
  public get TaskRecordQuery() {
    return readTaskRecordQuery(store);
  }

  // 获取复制需要的设备数据下拉框
  public get TaskRecordDevices() {
    return readTaskRecordDevices(store);
  }
  // 切换复制的id时，更新设备数据
  public async equipmentUpdate() {
    await dispatchtaskRecordDevices(store, {
      project: this.localProject,
      task_record_id: Number(this.copyVal.taskRecordId),
    });
  }

  // 复制接口禁用
  public get interfaceDisabled() {
    let disabled = false;
    if (
      this.get_is_super ||
      this.copyVal.taskRecordId === "" ||
      this.copyVal.deviceVal === "" ||
      this.copyVal.deviceVal === undefined
    ) {
      disabled = true;
    }
    return disabled;
  }

  //复制的接口
  public async CopyBtn() {
    this.loading = true;
    let copy = {
      project: this.localProject,
      task_record_id: this.copyVal.taskRecordId,
      device_id: this.copyVal.deviceVal,
      report_id: Number(this.$route.query.report_id),
    };
    await dispatchAovCopyPerfToReport(store, copy);
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: Number(this.$route.query.report_id),
    });
    await this.addressee; //解析邮件收件人
    await dispatchGetPerfReport(store, {
      project: this.localProject,
      report_id: Number(this.name_search),
    });
    this.datum_result = {};
    await this.perf_report();
    await this.get_create_report(); //启用生成报告的接口
    dispatchGetDateVersionList(store, {
      project: this.localProject,
    });
    // dispatchGetPerformanceSelectOptions(store, {
    //   project: this.localProject,
    // });
    dispatchGetDeviceSpecs(store, { project: this.localProject });
    await dispatchGetMobaProjects(store, this.localProject);
    if (this.projectIsKing) {
      dispatchGetHeroSkin(store, this.localProject);
    }
    await dispatchGetProjectScenes(store, { project: this.localProject });
    this.corePerformance = [];
    await this.getCorePerformance();
    this.get_core_data.report_list.unshift(this.get_core_data.report_list[0]);

    this.resBase64 = [];
    await this.legendArr.map((item, index) => {
      this.$nextTick(() => {
        this.performanceTrends_echarts(index, item.value); //图表
      });
    });
    await this.noDecimal();

    await this.judgeModel;
    this.loading = false;
  }

  // 小数
  public noDecimal() {
    let decimal = [
      "Avg(Memory)[MB]",
      "max_pss",
      "monomem",
      "avg_monomem",
      "Tris",
      "Verts",
    ];
    decimal.forEach((item: any) => {
      this.getnoDecimal("new", item);
      this.getnoDecimal("old", item);
      this.getnoDecimal("standard", item);
    });
  }

  public getnoDecimal(val1: any, val2: any) {
    this.get_core_data.report_list2.map((item: any) =>
      item[val1].map((item2: any) => {
        if (val1 === "standard") {
          if (
            item2[val2] === undefined ||
            item2[val2] === null ||
            item2[val2] === ""
          ) {
            item2[val2] = "--";
          } else {
            item2[val2] = Math.round(item2[val2]);
          }
        } else {
          if (
            item2.data[val2] === undefined ||
            item2.data[val2] === null ||
            item2.data[val2] === ""
          ) {
            item2.data[val2] = "--";
          } else {
            item2.data[val2] = Math.round(item2.data[val2]);
          }
        }
      })
    );
  }
  // 判断安卓/ios
  public modelVal = "安卓";
  public get judgeModel() {
    // this.get_core_data.able_versions.android_new_version = "";
    // this.get_core_data.able_versions.android_old_version = "";
    // this.get_core_data.able_versions.ios_new_version = "11";
    // this.get_core_data.able_versions.ios_old_version = "22";
    let ad_new = this.get_core_data.able_versions.android_new_version;
    let ad_old = this.get_core_data.able_versions.android_old_version;
    let ios_new = this.get_core_data.able_versions.ios_new_version;
    let ios_old = this.get_core_data.able_versions.ios_old_version;
    if (
      (ad_new !== "" || ad_old !== "") &&
      (ios_new !== "" || ios_old !== "")
    ) {
      this.modelVal = "安卓/iOS";
    } else if (ios_new !== "" || ios_old !== "") {
      this.modelVal = "iOS";
    }
    return this.modelVal;
  }
  //报告名称
  public name_search = "";
  //获取报告名称的列表
  public get nameList() {
    let name_list: any[] = [];
    name_list = readNewReportList(store);
    return name_list;
  }
  // 邮件
  public edit = false;
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  public datum_result: any = {};
  // 点击发送
  public sendOut() {
    this.edit = !this.edit;
  }
  // 解析邮件收件人
  public get addressee() {
    let addressee = JSON.parse(readNewReport(store).settings).report_settings
      .notify.email.receiver_str;
    this.formMail.addressee = addressee;

    return addressee;
  }
  // 这些aov指标降低是好的
  public good_params = [
    "avg_fps",
    "fps_lt_18_pcnt",
    "fps_lt_25_pcnt",
    "Var(FPS)",
    "FTime>=100[%]",
  ];

  // 报告名称切换时
  public async change_name_search() {
    this.loading = true;
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 0,
    });
    // this.name_search = readNewReportList(store)[0].id;
    // 邮件标题
    this.$router.push({
      query: { ...this.$route.query, report_id: this.name_search },
    });
    this.formMail.title = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.name_search
    )[0].report_name;
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: Number(this.name_search),
    });
    await this.addressee; //解析邮件收件人

    this.report_id = readNewReport(store).id;
    await dispatchGetPerfReport(store, {
      project: this.localProject,
      report_id: Number(this.name_search),
      interval: this.interval,
    });
    this.datum_result = {};
    await this.perf_report();
    await this.get_create_report(); //启用生成报告的接口
    dispatchGetDateVersionList(store, {
      project: this.localProject,
    });
    // dispatchGetPerformanceSelectOptions(store, {
    //   project: this.localProject,
    // });
    dispatchGetDeviceSpecs(store, { project: this.localProject });
    await dispatchGetMobaProjects(store, this.localProject);
    if (this.projectIsKing) {
      dispatchGetHeroSkin(store, this.localProject);
    }
    await dispatchGetProjectScenes(store, { project: this.localProject });
    this.corePerformance = [];
    await this.getCorePerformance();
    // await dispatchtaskRecordQuery(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //aov复制数据需要的任务记录列表接口
    // await dispatchtaskRecordDevices(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //获取任务记录的设备
    this.get_core_data.report_list.unshift(this.get_core_data.report_list[0]);
    this.resBase64 = [];
    await this.legendArr.map((item, index) => {
      this.$nextTick(() => {
        this.performanceTrends_echarts(index, item.value); //图表
      });
    });
    // await this.scrollBar()//判断是否有滚动条
    await this.noDecimal();

    await this.judgeModel;

    this.loading = false;
  }
  public get RecentTaskrecord() {
    return readRecentTaskrecord(store);
  }
  // 点击删除
  public async handleDelete() {
    this.loading = true;
    await dispatchDeleteReport(store, {
      project: this.localProject,
      report_id: Number(this.name_search),
      page: 1,
      size: 1,
      report_name: "",
      new_version: "",
      old_version: "",
      risk: "",
      creator: "",
    });
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 0,
    });

    this.name_search = readNewReportList(store)[0].id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.name_search },
    });
    // 邮件标题
    this.formMail.title = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.name_search
    )[0].report_name;
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: Number(this.name_search),
    });
    await this.addressee; //解析邮件收件人

    this.report_id = readNewReport(store).id;
    await dispatchGetPerfReport(store, {
      project: this.localProject,
      report_id: Number(this.name_search),
      interval: this.interval,
    });
    this.datum_result = {};
    await this.perf_report();
    await this.get_create_report(); //启用生成报告的接口
    dispatchGetDateVersionList(store, {
      project: this.localProject,
    });
    // dispatchGetPerformanceSelectOptions(store, {
    //   project: this.localProject,
    // });
    dispatchGetDeviceSpecs(store, { project: this.localProject });
    await dispatchGetMobaProjects(store, this.localProject);
    if (this.projectIsKing) {
      dispatchGetHeroSkin(store, this.localProject);
    }
    await dispatchGetProjectScenes(store, { project: this.localProject });
    this.corePerformance = [];
    await this.getCorePerformance();
    // await dispatchtaskRecordQuery(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //aov复制数据需要的任务记录列表接口
    // await dispatchtaskRecordDevices(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //获取任务记录的设备
    this.get_core_data.report_list.unshift(this.get_core_data.report_list[0]);
    this.resBase64 = [];
    await this.legendArr.map((item, index) => {
      this.$nextTick(() => {
        this.performanceTrends_echarts(index, item.value); //图表
      });
    });
    // await this.scrollBar()//判断是否有滚动条
    await this.noDecimal();

    await this.judgeModel;

    this.loading = false;
  }
  public async refresh() {
    this.loading = true;
    await dispatchGetPerfReport(store, {
      project: this.localProject,
      report_id: this.report_id,
      interval: this.interval,
    });
    this.datum_result = {};
    await this.perf_report();
    this.loading = false;
  }
}
